/**
 * TODO: documentation
 */


const baseClass = 'bonemodal';

const defaultSettings = {
	baseClass:			 baseClass, // string
	openAnimationCB:	 null, // function
	closeAnimationCB:	 null, // function
	onOpen:				 null, // function
	onClose:			 null, // function
	customParent:		 null, // HTMLElement (note, this may cause issues with swup)
}


/**
 *
 * @param {HTMLElement|string} rootElem accepts a DOM element or a string ID
 * @param {Object} settings
 * @returns {Object}
 */
const BoneModal = (rootElem, settings = {}) => {

	const modal = {
		id: null,
		elem: null,
		clickTrap: null,
		settings: defaultSettings,
		instantiated: false,
	}

	modal._init = function() {
		if (!rootElem) {
			return;
		}

		modal.settings = Object.assign({}, modal.settings, settings);
		modal.elem = rootElem;
		modal.id = rootElem.id;


		const triggers = modal.getTriggers();

		triggers.openTriggers.forEach(trigger => {
			trigger.addEventListener('click', modal._onRequestModalOpen);
		});

		triggers.closeTriggers.forEach(trigger => {
			trigger.addEventListener('click', modal._onRequestModalClose);
		});

		triggers.toggleTriggers.forEach(trigger => {
			trigger.addEventListener('click', modal._onRequestModalToggle);
		});

		const clickTrap = getClickTrap(modal);
		if (clickTrap) {
			console.log({clickTrap})
			modal.clickTrap = clickTrap;
			clickTrap.addEventListener('click', modal.close);
		}

		// modal._relocateTo(modal.settings.customParent || document.body);
		modal.elem.BoneModal = modal; // add this to the element so it can be referenced globally

		modal.instantiated = true;
	}


	modal.isOpen = function() {
		if (modal.elem) {
			return modal.elem.getAttribute('aria-hidden') === 'false';
		}
		else {
			return false;
		}
	}

	modal.open = function() {
		if (!modal.elem) {
			return;
		}

		document.body.classList.add('modal-active');
		// add a lock so other modals don't remove the active class
		document.body.classList.add(`modal-lock--${modal.id}`);

		modal.elem.setAttribute('aria-hidden', 'false');
		modal.elem.focus();
		window.addEventListener('keydown', modal._closeModalOnEscapeKey);

		if (modal.settings.onOpen) {
			modal.settings.onOpen();
		}

		if (modal.settings.openAnimationCB) {
			modal.settings.openAnimationCB(modal.elem);
		}
	}

	modal.close = function() {
		if (!modal.elem) {
			return;
		}

		// remove lock
		document.body.classList.remove(`modal-lock--${modal.id}`);

		// check if any other modals have set a lock...
		const locks = Array
			.from(document.body.classList)
			.filter(cls => cls.startsWith('modal-lock--'));

		// ...if not, it is safe to remove the active class
		if (!locks.length) {
			document.body.classList.remove('modal-active');
		}

		modal.elem.setAttribute('aria-hidden', 'true');
		window.removeEventListener('keydown', modal._closeModalOnEscapeKey);

		if (modal.settings.onClose) {
			modal.settings.onClose();
		}

		if (modal.settings.closeAnimationCB) {
			modal.settings.closeAnimationCB(modal.elem);
		}
	}

	modal._closeModalOnEscapeKey = function(e) {
		if (e.key === 'Escape') {
			modal.close();
		}
	}

	modal.getTriggers = function() {
		return getAllTriggers(modal);
	}

	modal._onRequestModalOpen = function() {
		modal.open();
	}

	modal._onRequestModalClose = function() {
		modal.close();
	}

	modal._onRequestModalToggle = function() {
		if (modal.isOpen()) {
			modal.close();
		}
		else {
			modal.open();
		}
	}

	/**
	 *
	 * @param {HTMLElement} newParent
	 */
	modal._relocateTo = function(newParent) {
		if (modal.elem && newParent) {
			newParent.appendChild(modal.elem);
		}
	}


	// TODO: remove event listeners
	modal.destroy = function() {
		const triggers = modal.getTriggers();

		triggers.openTriggers.forEach(trigger => {
			trigger.removeEventListener('click', modal._onRequestModalOpen);
		});

		triggers.closeTriggers.forEach(trigger => {
			trigger.removeEventListener('click', modal._onRequestModalClose);
		});

		triggers.toggleTriggers.forEach(trigger => {
			trigger.removeEventListener('click', modal._onRequestModalToggle);
		});

		if (modal.clickTrap) {
			modal.clickTrap.removeEventListener('click', modal.close);
		}

		delete modal.elem.BoneModal;

		modal.id = null;
		modal.elem = null;
		modal.clickTrap = null;
		modal.settings = defaultSettings;
		modal.instantiated = false;
	}



	modal._init();

	return modal;
};

/**
 *
 * @param {BoneModal} modal
 * @returns {Object<Array>}
 */
function getAllTriggers(modal) {
	const triggers = {
		openTriggers: getOpenTriggers(modal),
		closeTriggers: getCloseTriggers(modal),
		toggleTriggers: getToggleTriggers(modal),
	}

	return triggers;
}

function getOpenTriggers(modal) {
	return getTriggersByType(modal, 'open');
}

function getCloseTriggers(modal) {
	return getTriggersByType(modal, 'close');
}

function getToggleTriggers(modal) {
	return getTriggersByType(modal, 'toggle');
}


/**
 *
 * @param {BoneModal} modal
 * @param {string} type
 * @returns {Array}
 */
 function getTriggersByType(modal, type) {
	if (!modal || !type) {
		return [];
	}

	// anywhere on page - requires the data-trigger-for attribute
	const globalTriggers = Array.from(
		document.querySelectorAll(`[data-${type}-trigger-for="${modal.id}"]`)
	);

	// within the modal. Doesn't require data-trigger-for, but if it has it
	// it can't be for another modal
	let childTriggers = Array.from(
		modal.elem.querySelectorAll(`[data-${type}-trigger-for]`)
	);

	const triggers = [...globalTriggers];
	if (childTriggers.length) {
		childTriggers.forEach(trigger => {
			if (!globalTriggers.includes(trigger)) {
				triggers.push(trigger);
			}
		})
	}

	return triggers;
}

/**
 *
 * @param {BoneModal} modal
 * @param {string} type
 * @returns {Array}
 */
 function getClickTrap(modal) {
	if (!modal || !modal.elem) {
		return null;
	}

	const clickTrap = modal.elem.querySelector(`.${modal.settings.baseClass}__click-trap`);
	return clickTrap;
}

/**
 *
 * @param {HTMLElement|string} rootElem accepts a DOM element or a string ID
 * @returns {HTMLElement|null}
 */
function getDomElementFromRef(ref) {
	let elem = null;
	if (typeof ref === 'string') {
		elem = document.getElementById(ref);
	}
	else if (ref && ref.tagName) { // could improve this check for dom node
		elem = ref;
	}

	return elem;
}


/**
 *
 * @param {HTMLElement|string} rootElem accepts a DOM element or a string ID
 */
function openModal(ref) {
	const elem = getDomElementFromRef(ref)

	if (elem && elem.BoneModal) {
		elem.BoneModal.open();
	}
}


/**
 *
 * @param {HTMLElement|string} rootElem accepts a DOM element or a string ID
 */
 function closeModal(ref) {
	const elem = getDomElementFromRef(ref)

	if (elem && elem.BoneModal) {
		elem.BoneModal.close();
	}
}

export {
	BoneModal,
	openModal,
	closeModal,
}



// WEBPACK FOOTER //
// ./scripts/modules/BoneModal.js